/* eslint-disable */

<template>
  <div class="wraper">
    <div class="menu">
      <span id="list-title">Scenariusze</span>
      <div
        class="menu-btn"
        @click.prevent="usage = 1"
        :class="{ active: usage == 1 }"
      >
        <span class="menu-dot"></span>
        1
      </div>
      <div
        class="menu-btn"
        @click.prevent="usage = 2"
        :class="{ active: usage == 2 }"
      >
        <span class="menu-dot"></span>
        2
      </div>
    </div>

    <div class="usage-body">
      <div class="content">
        <div v-if="usage == 1">
          <h3>Kolektywizacja wsi polskiej</h3>
          <h5>Czym była kolektywizacja?</h5>
          <p>
            Po roku 1945 władze komunistyczne dążyły do wprowadzania na terenie
            Rzeczpospolitej Polskiej (a po zmianie nazwy w 1952 roku w Polskiej
            Rzeczpospolitej Ludowej) sowieckich wzorców gospodarczych. Jednym z
            nich była kolektywna gospodarka rolna, oparta na tzw. społecznej
            własności ziemi i maszyn oraz na dzieleniu się z państwem plonami i
            efektami hodowli, co w praktyce oznaczało system przymusowych
            kontyngentów i dostaw dla państwa. W ZSRR takimi kolektywnymi
            gospodarstwami były
            <span
              class="info"
              title="Ros. колхоз, skrót od коллективное хозяйство (kollektiwnoje choziajstwo), czyli gospodarstwo wspólnotowe."
              >kołchozy</span
            >
            i
            <span
              class="info"
              title="Ros. совхоз, skrót od советское хозяйство (sowietskoje choziajstwo), czyli
gospodarstwo radzieckie."
              >sowchozy</span
            >
            . Kolektywizacja wymagała jednak odebrania polskim chłopom ziemi –
            tej ziemi, którą władze komunistyczne obiecały im w Manifeście
            Polskiego Komitetu Wyzwolenia Narodowego (PKWN) z lipca 1944, a
            później nadały podczas reformy rolnej dekretem PKWN z września tegoż
            roku.
          </p>

          <h5>Czy było to zdarzenie nowe w historii Polski?</h5>
          <p>
            Cofnijmy się do wieku XIX. Warto przypomnieć, że w 1944 roku rękami
            polskich kolaborantów (albowiem PKWN realizował interesy władz ZSRR)
            Sowieci powtórzyli manewr podobny do tego, który carat wykonał
            podczas
            <span
              class="info"
              title="Jedno z dwóch największych polskich powstań narodowych w XIX wieku. Trwało od
stycznia 1863 do jesieni 1864 i objęło ziemie Królestwa Polskiego oraz Litwy
(zabór rosyjski). Miało charakter wojny partyzanckiej. Mimo porażki militarnej i
masowych represji caratu (egzekucje, zesłania, konfiskaty mienia) powstanie
przyczyniło się do podtrzymania tożsamości narodowej Polaków i utrudniło proces
postępującej rusyfikacji ludności.
"
              >powstania styczniowego</span
            >
            w 1864, uwłaszczając chłopów w zaborze rosyjskim. Wówczas bardzo
            utrudniło to przywódcom powstania włączenie w ruch
            narodowowyzwoleńczy warstwy chłopskiej – najliczniejszej w
            społeczeństwie polskim. Natomiast w roku 1944 Sowietom w ten sam
            sposób udało się osłabić powstania styczniowego
            <span
              class="info"
              title="Legalną władzą Rzeczpospolitej Polskiej w 1944 roku był Rząd na
uchodźstwie, reprezentowany przez administrację cywilną (Delegatura Rządu na Kraj) i
dysponujący oddziałami Armii Krajowej."
              >legalne władze Rzeczpospolitej</span
            >, zyskując przychylność tej części chłopstwa, której komuniści
            obiecali przekazać na własność „ziemię obszarniczą” po parcelacji –
            oczywiście w zamian za poparcie. W rzeczywistości komunizm w wydaniu
            sowieckim zwalczał własność prywatną, a ukrytym celem
            przeprowadzenia reformy rolnej w Polsce było zniszczenie warstwy
            ziemiańskiej, będącej nośnikiem tradycji niepodległościowej.
          </p>
          <h5>Jak wyglądała kolektywizacja na ziemiach polskich?</h5>
          <p>
            Gdy komuniści zdobyli w Polsce pełnię władzy politycznej, co
            nastąpiło pod koniec 1948 roku, energicznie przystąpili do
            kolektywizacji wsi. Jednak naiwnością byłoby sądzić, że polskim
            chłopom można po prostu zabrać to, co się im wcześniej dało. Tym
            bardziej że władza nie chciała zbyt ostentacyjnie wycofywać się ze
            swoich wcześniejszych obietnic. Dlatego ówcześni propagandyści
            zastosowali stary jak świat zabieg „zmiany etykiet”, polegający na
            nazwaniu planowanego deliktu w sposób niebudzący niepożądanych
            skojarzeń. I tak słowo ‘kolektywizacja’ zastąpiono rozwojem
            ‘gospodarki spółdzielczej’, a ‘kołchoz’ – ‘rolniczą spółdzielnią
            produkcyjną’. Na tej samej zasadzie w publicznym dyskursie państw
            totalitarnych ‘zabijanie’ zastępowano ‘eliminacją’ czy ‘likwidacją’,
            ‘strajki’ – ‘przerwami w pracy’, a ‘reżim totalitarny’ – ‘demokracją
            ludową’. Władze komunistyczne zawłaszczyły więc pozytywnie
            nacechowane słownictwo i wykorzystały piękną tradycję prawdziwej
            spółdzielczości, przez pokolenia tworzonej oddolnie m.in. pod egidą
            Polskiej Partii Socjalistycznej. Można przy okazji dodać, że rodzący
            się wówczas nowy język państwa totalitarnego określany jest w
            literaturze przedmiotu jako
            <span
              class="info"
              title="Mianem nowomowy określa się zniekształcony język publiczny państw totalitarnych, w szczególności komunistycznych i faszystowskich. Jego nazwa pochodzi od angielskiego wyrazu newspeak, użytego przez George’a Orwella w powieści „Rok 1984”, ukończonej tuż po zakończeniu drugiej wojny światowej. Orwell wprowadził tam schematy zaobserwowane w propagandzie i funkcjonowaniu kształtujących się w XX wieku państw totalitarnych Europy – Hiszpanii, Niemiec Hitlerowskich, a przede wszystkim Rosji Sowieckiej. Oto w fikcyjnym państwie Oceania władze stworzyły nowy język (Orwell stworzył w tym celu neologizm ‘newspeak’) i narzuciły go swoim obywatelom, odcinając ich od języka ‘starego’. Język nowy miał być narzędziem kontroli słów i myśli obywateli, a w konsekwencji także ich zachowania. Determinował światopogląd całego społeczeństwa, ponieważ uniemożliwiał wyrażenie idei czy pojęć niezgodnych z oficjalną doktryną: usunięto z niego niepożądane wyrazy, a tym, których nie dało się usunąć, zmieniono znaczenia. Wśród cech nowomowy wymienia się m.in.: permanentne wartościowanie (wszystko jest albo dobre, albo złe), rytualność i etykietowanie (powtarzanie do znudzenia tych samych formuł), perswazyjność (teksty nie informują, lecz przekonują), dominacja funkcji magicznej (samo wypowiadanie słów, na przykład sloganu, ma tworzyć nową rzeczywistość) i obecność figury wroga (np. kapitalizmu, rewanżystów zachodnioniemieckich, band reakcyjnych, postaci kułaka itd.). Powieść Orwella należy do gatunku dystopii, czyli utopii katastroficznych (sama nazwa ‘Oceania’ jest antytezą rajskiej Atlantydy). Zyskała ona wielką popularność, stając się kulturowym symbolem totalitaryzmu."
              >leksemów</span
            >
            Aby jednak operację kolektywizacji przeprowadzić sprawnie, na wsi
            potrzebna była intensywna agitacja, którą prowadzili przedstawiciele
            władzy, korzystając z pomocy ówczesnej prasy. Właśnie ten wymiar
            kolektywizacji można dość dokładnie prześledzić metodami analizy
            korpusowej, korzystając z zasobów i narzędzi ChronoPressu.
          </p>
          <h5>Jak korpus tekstów może pomóc w zrozumieniu tego zjawiska?</h5>
          <p>
            Korpus prasy ChronoPress (docelowo lata 1944–1990) zawiera
            reprezentację dyskursu prasowego epoki PRL. Badając frekwencje
            niektórych wyrazów (lub ich zbiorów) można wyświetlić (dosłownie i w
            przenośni) dynamikę zjawisk społecznych i gospodarczych. Badanie
            frekwencji użycia w prasie
            <span
              class="info"
              title="Leksem w praktyce lingwistycznej to zbiór wyrazów należących do paradygmatu odmiany danego wyrazu – tutaj jest to ‘spółdzielnia’ lub ‘spółdzielczy’. Na leksem ‘spółdzielnia’ składają się więc formy wyrazowe ‘spółdzielnia’, ‘spółdzielnie’,‘spółdzielni’, ‘spółdzielnią’ etc."
              >leksemów</span
            >
            ‘spółdzielnia’ lub ‘spółdzielczy’ ujawnia realną siłę i dynamikę
            presji wywieranej przez państwo na kolektywizację polskiej wsi.
            Wykres poniżej został wygenerowany funkcją szeregu czasowego z
            portalu ChronoPress. Zsumowano frekwencję leksemów ‘spółdzielnia’ i
            ‘spółdzielczy’. Wykres ujawnia, że presja na kolektywizację (a więc
            de facto zrzekanie się własności ziemi przez właścicieli i wnoszenie
            jej do majątku spółdzielni) rozpoczyna się około roku XX, narasta do
            XX, a w końcu gwałtownie spada w roku XX, kiedy to władze
            uświadomiły sobie, że skuteczna kolektywizacja polskiej wsi jest to
            niewykonalna i trzeba się z tego planu wycofać. Wykres 1. Histogram
            frekwencji leksemów ‘spółdzielnia’ i spółdzielczy’ XXX
          </p>
          <h5>Czy dane korpusowe pozawalają na interpretacje jakościowe?</h5>
          <p>
            Jest faktem, że korpus oparty na reprezentacji publikacji prasowych
            nie jest biblioteką cyfrową i nie pełni funkcji typowego zbioru
            dokumentów. Daje wgląd jedynie we fragmenty gazet i czasopism,
            wybierane metodą losową. Cytaty takie dostępne są jednak w wielkiej
            liczbie i można stosunkowo łatwo wydobyć z nich wiele cennych
            informacji, których pozyskanie metodą tradycyjną zajęłoby bardzo
            dużo czasu (ang. text mining). Można więc powiedzieć, że oprócz
            parametrów ilościowych korpus dostarcza syntetycznych danych, które
            ułatwiają zrozumienie i interpretację badanych zjawisk.
          </p>
          <h5>Do czego służy analiza konkordancji?</h5>
          <p>
            Kliknięcie w punkt na wykresie szeregu czasowego (histogramu)
            uruchamia wyszukiwarkę
            <span
              class="info"
              title="Konkordancja we współczesnej statystyce leksykalnej to
              lista wystąpień leksemu bądź formy wyrazowej w kontekstach
              wraz z odwołaniami do źródła cytatu. W historii przetwarzania
              danych źródeł konkordancji należy szukać w ponad tysiącletniej
              praktyce badań tekstu Biblii (egzegeza).
              Pierwsze konkordancje biblijne były zestawieniami wyrazów
              powtarzających się czterech Ewangeliach, tworzących kanon
              Chrześcijaństwa. Zamiast (a niekiedy oprócz) bezpośredniego
              kontekstu użycia ich autorzy podawali nazwę ewangelii i numer wersu,
              w którym dany wyraz wystąpił."
              >konkordancji</span
            >. Czytając krótkie konteksty użycia konkretnego wyrazu (tzw.
            ośrodka konkordancji) można szybko zorientować się w jego użyciach i
            wydźwięku. Tabelka poniżej przedstawia konkordancję leksemu
            ‘spółdzielnia’ w korpusie ChronoPress. Konkordancje można też
            generować i eksportować w postaci pliku bezpośrednio z modułu
            ‘Konkordancje’. Jeżeli linia konkordancji wydaje się za krótka,
            kliknięcie w nią pozwala wyświetlić cały fragment z metadanymi. Tab.
            1 Konkordancja leksemu ‘spółdzielnia’ w korpusie prasowym. XXX
          </p>
          <h5>Do czego służą profile wyrazów/pojęć?</h5>
          <p>
            Konteksty występujące na liście konkordancji mogą zostać oczywiście
            przeczytane przez człowieka. Kiedy jednak ich liczba jest wysoka, a
            w dodatku szuka się w nich relacji i mierzalnych (a więc obiektywnie
            porównywalnych) prawidłowości, łatwiej jest poddać takie konteksty
            analizie automatycznej. Wykresy poniżej ukazują profile semantyczne
            leksemu ‘spółdzielnia’. Wartości wyświetlone są odsetkiem kolejnych
            wyrazów pojawiających się najczęściej w lewym i prawym kontekście
            ośrodka konkordancji (czyli leksemu ‘spółdzielnia’) w odległości od
            1 do 3 wyrazów. Wykres pierwszy nie różnicuje klas wyrazowych (mamy
            więc rzeczowniki, czasowniki i przymiotniki). Wykres drugi podaje
            tylko przymiotniki. Wyniki te można poddać stosownej interpretacji.
            Wykres 2. Profil semantyczny leksemu ‘spółdzielnia’ (wszystkie
            części mowy) XXX Wykres 3. Profil semantyczny leksemu ‘spółdzielnia’
            (przymiotniki) XXX Powyższe podejście do analizy kontekstu nie jest
            jedynym, premiuje bowiem typowość (czyli wysokie frekwencje)
            połączeń wyrazowych, a nie ich wyjątkowość czy specyficzność w
            stosunku do języka ogólnego (czyli statystycznego wzorca
            przeciętności). Istnieją również analizatory kontekstu rozpoznające
            automatycznie połączenia nietypowe czy w jakiś sposób oryginalne.
            Wybór zastosowanego narzędzia zależny jest od postawionego pytania i
            oczekiwań badacza (w przypadku ChronoPressu jest to typowość).
          </p>
          <h5>Kiedy dane korpusowe są niezastąpione?</h5>
          <p>
            Profile leksykalne można wyznaczać także metodą ankietową (Wypisz
            przymiotniki, które kojarzą cię się z wyrazem ‘spółdzielnia’),
            zwracając się do grupy respondentów. Otrzymujemy wtedy uśredniony
            obraz mentalny danego pojęcia czy przedmiotu. Jednak obraz taki jest
            z konieczności współczesny ludziom, którzy są w danym momencie
            pytani. Zaletą podejścia korpusowego jest możliwość „pytania” o
            profil pojęć wyłącznie na podstawie
            <span
              class="info"
              title="Dystrybucja danego wyrazu to jednostki towarzyszące z lewej i prawej strony w linii tekstu."
              >dystrybucji</span
            >
            leksemów w tekstach. Wiele korpusów odzwierciedla czasy minione,
            często poza pamięcią współczesnych, ale w orbicie ich zainteresowań.
            Profilowanie pojęć (leksemów) metodami ankietowymi jest więc w
            takiej sytuacji niemożliwe.
          </p>
          <h5>Dlaczego analiza korpusowa i korpus ChronoPress są przydatne?</h5>
          <p>
            Analiza korpusowa i reprezentatywny korpus tekstów stanowią
            narzędzie pomocnicze wielu dyscyplin humanistyki i nauk społecznych.
            Pozwala ono na eksplorację danych i odkrywanie parametrów
            ilościowych tekstu, a także niewidocznych z pozoru zależności i
            prawidłowości. Dzięki wymiarowi ilościowemu owe parametry,
            zależności i prawidłowości są naukowo bardziej przydatne, niż luźne
            impresje z lektury. Przykładem takiej analizy korpusowej jest
            ilościowy opis prasowego obrazu kolektywizacji wsi polskiej w latach
            powojennych. Może on posłużyć jako pomoc w badaniach m.in.
            historykom, antropologom, lingwistom i medioznawcom. Cechy korpusu
            ChronoPress, które wyróżniają go na tle innych narzędzi i pozwalają
            na takie analizy, to: – zawartość (trudno dostępne i zrównoważone
            tematycznie dane z tekstów prasowych z okresu PRL); – uporządkowanie
            chronologiczne (systematyczne daty wydań, które pozwalają na
            stosowanie różnych metod analizy chronologicznej danych); – spójne
            metadane.

            <br /><br />

            <i>Przygotowanie: Adam Pawłowski </i>
          </p>
        </div>

        <div v-if="usage == 2">
          <h3>Czas w badaniach korpusowych: schemat katastrofy</h3>
          <p>
            Czas jest pojęciem wyjątkowym, ponieważ praktycznie w żadnej
            dziedzinie nauki nie istnieje jego zadowalająca definicja. Chociaż
            jednak człowiek nie potrafi czasu zdefiniować, rozpoznaje skutki
            jego istnienia lub związane z nim zjawiska (ruch przedmiotów, rozwój
            organizmów, wygląd człowieka itd.). W korpusowych badaniach tekstów
            czas występuje w kilku aspektach: strukturalnym (liniowy, kolisty,
            mieszany), antropologicznym (astronomiczny, kulturowy, polityczny) i
            metodologicznym (modele trendu, oscylacji periodycznych, katastrofy,
            wahań losowych).
          </p>
          <h5>Czas w tekście i języku</h5>
          <p>
            Z metodologicznego punktu widzenia czas w języku może być
            postrzegany różnie. Istnieją środki językowe, służące do wyrażania
            tego zjawiska w opisywanej rzeczywistości (czas gramatyczny
            czasowników, częściowo także aspekt). Ale w języku, podobnie jak w
            organizmach żywych, widoczne są także skutki działania czasu, czyli
            ewolucja form, struktur i znaczeń, dostrzegana, kiedy porówna się
            stan języka w dostatecznie długim odstępie (na przykład 200-300
            lat). Dla Europejczyków doskonale ilustrują takie zmiany wyrazy
            języków romańskich, wywodzące się z łaciny, a więc doskonale
            opisanego języka przodka, używanego w starożytności. Można jednak
            odkrywać działanie czasu w tekstach jeszcze w inny sposób –
            obserwując zmieniającą się frekwencję użycia wyrazów w dłuższym
            odcinku czasu. Jest to związane z różną intensywnością
            zainteresowania opisywanymi tematami w różnych okresach. Właśnie
            takie podejście można zastosować na korpusie chronologicznym.
            Pozwala on ujawnić zmieniającą się obecność dowolnych tematów w
            tekstach, należących do dyskursu publicznego. Na generowane
            histogramy frekwencji należy patrzeć przez pryzmat pewnych modeli
            (trend, oscylacja, katastrofa). Poniżej przedstawiam analizę
            czynnika czasu w tekstach, stosując model katastrofy.
          </p>
          <h5>Schemat katastrofy</h5>
          <p>
            Pojęcie katastrofy z metodologicznego punktu widzenia oznacza każdą
            anomalię, a więc zdarzenie jednorazowe, niepowtarzalne, odbiegające
            w istotny sposób od normalnego porządku rzeczy. Warto zauważyć, że
            wbrew potocznemu rozumieniu tego pojęcia anomalią mogą być również
            wydarzenia pozytywne, które pod względem frekwencji leksemów w
            tekstach manifestują się w taki sam sposób, jak katastrofy oceniane
            jako „negatywne”. Poniżej przedstawiam kilka klas zdarzeń, które
            media wykreowały na katastrofy.
          </p>
          <h5>Śmierć znanej osoby</h5>
          <p>
            W 1953 roku umiera Józef Stalin, przywódca ZSRR i lider światowego
            ruchu komunistycznego. sowych kontyngentów i dostaw dla państwa. W
            ZSRR takimi kolektywnymi gospodarstwami były kołchozy (Ros. колхоз,
            skrót od коллективное хозяйство (kollektiwnoje choziajstwo), czyli
            gospodarstwo wspólnotowe.) i sowchozy (Ros. совхоз, skrót od
            советское хозяйство (sowietskoje choziajstwo), czyli gospodarstwo
            radzieckie.). Kolektywizacja wymagała jednak odebrania polskim
            chłopom ziemi – tej ziemi, którą władze komunistyczne obiecały im w
            Manifeście Polskiego Komitetu Wyzwolenia Narodowego (PKWN) z lipca
            1944, a później nadały podczas reformy rolnej dekretem PKWN z
            września tegoż roku.
          </p>

          <br /><br />
          <h3>Wyjątkowe zdarzenie</h3>
          <h5>Katastrofa naturalna lub techniczna</h5>
          <span class="text-center">
            <i
              >Wykres 1. Histogram frekwencji leksemów ‘spółdzielnia’ i
              spółdzielczy’</i
            ></span
          >
          <h5>Czy dane korpusowe pozawalają na interpretacje jakościowe?</h5>
          <p>
            Jest faktem, że korpus oparty na reprezentacji publikacji prasowych
            nie jest biblioteką cyfrową i nie pełni funkcji typowego zbioru
            dokumentów. Daje wgląd jedynie we fragmenty gazet i czasopism,
            wybierane metodą losową. Cytaty takie dostępne są jednak w wielkiej
            liczbie i można stosunkowo łatwo wydobyć z nich wiele cennych
            informacji, których pozyskanie metodą tradycyjną zajęłoby bardzo
            dużo czasu. Można więc powiedzieć, że oprócz parametrów ilościowych
            korpus dostarcza syntetycznych danych, które ułatwiają zrozumienie i
            interpretację badanych zjawisk.
          </p>
          <h5>Konkordancje</h5>
          <p>
            Klikęcie w punkt na wykresie szeregu czasowego (histogramu)
            uruchamia wyszukiwarkę konkordancji (Konkordancja we współczesnej
            statystyce leksykalnej to lista wystąpień leksemu bądź formy
            wyrazowej w kontekstach. Jednak w historii przetwarzania danych
            źródeł konkordancji należy szukać w ponad tysiącletniej praktyce
            badań tekstu Biblii. Pierwsze konkordancje biblijne były
            zestawieniami wyrazów powtarzających się czterech Ewangeliach,
            tworzących kanon Chrześcijaństwa. Zamiast (a niekiedy oprócz)
            bezpośredniego kontekstu użycia ich autorzy podawali nazwę ewangelii
            i numer wersu, w którym dany wyraz wystąpił.). Czytając krótkie
            konteksty użycia konkretnego wyrazu (tzw. ośrodka konkordancji)
            można szybko zorientować się w jego użyciach i wydźwięku. Tabelka
            poniżej przedstawia konkordancję leksemu ‘spółdzielnia’ w korpusie
            ChronoPress. Konkordancje można też generować i eksportować w
            postaci pliku bezpośrednio z modułu ‘Konkordancje’. Jeżeli linia
            konkordancji wydaja się za krótka, kliknięcie w nią pozwala
            wyświetlić cały fragment z metadanymi.

            <br /><i
              >Tab. 1 Konkordancja leksemu ‘spółdzielnia’ w korpusie prasowym.
            </i>
          </p>
          <h5>Profile wyrazów (pojęć)</h5>
          <p>
            Konteksty występujące na liście konkordancji mogą zostać oczywiście
            przeczytane przez człowieka. Kiedy jednak ich liczba jest wysoka, a
            w dodatku szuka się w nich relacji i mierzalnych (a więc obiektywnie
            porównywalnych) prawidłowości, łatwiej jest poddać takie konteksty
            analizie automatycznej. Wykresy poniżej ukazują profile semantyczne
            leksemu ‘spółdzielnia’. Wartości wyświetlone są odsetkiem kolejnych
            wyrazów pojawiających się najczęściej w lewym i prawym kontekście
            ośrodka konkordancji (czyli leksemu ‘spółdzielnia’) w odległości od
            1 do 3 wyrazów. Wykres pierwszy nie różnicuje klas wyrazowych (mamy
            więc rzeczowniki, czasowniki i przymiotniki). Wykres drugi podaje
            tylko czasowniki. ANALIZA

            <i
              >Wykres 2. Profil semantyczny leksemu ‘spółdzielnia’ (wszystkie
              części mowy)</i
            >

            <br />
            <i>
              Wykres 3. Profil semantyczny leksemu ‘spółdzielnia’ (czasowniki)
            </i>

            Powyższe podejście do analizy kontekstu nie jest jedynym, premiuje
            bowiem typowość (czyli wysokie frekwencje) połączeń wyrazowych, a
            nie ich wyjątkowość czy specyficzność w stosunku do języka ogólnego.
            Istnieją również analizatory kontekstu rozpoznające automatycznie
            połączenia nietypowe czy w jakiś sposób oryginalne. Wybór
            zastosowanego narzędzia zależny jest od postawionego pytania i
            oczekiwań badacza (w przypadku ChronoPressu jest to typowość).
          </p>
          <h5>Komentarz Profile</h5>
          <p>
            leksykalne można wyznaczać także metodą ankietową (Wypisz
            przymiotniki, które kojarzą cię się z wyrazem ‘spółdzielnia’),
            zwracając się do grupy respondentów. Otrzymujemy wtedy uśredniony
            obraz mentalny danego pojęcia czy przedmiotu. Jednak obraz taki jest
            z konieczności współczesny ludziom, którzy są w danym momencie
            pytani. Zaletą podejścia korpusowego jest możliwość „pytania” o
            profil pojęć wyłącznie na podstawie dystrybucji (Dystrybucja danego
            wyrazu to jednostki towarzyszące z lewej i prawej strony w linii
            tekstu.) leksemów w tekstach. Wiele korpusów odzwierciedla czasy
            minione, często poza pamięcią współczesnych, ale w orbicie ich
            zainteresowań. Profilowanie pojęć (leksemów) metodami ankietowymi
            jest więc w takiej sytuacji niemożliwe.
          </p>
          <h5>Podsumowanie Analiza</h5>
          <p>
            korpusowa i reprezentatywny korpus tekstów stanowią narzędzie
            pomocnicze wielu dyscyplin humanistyki i nauk społecznych. Pozwala
            ono na eksplorację danych i odkrywanie parametrów ilościowych
            tekstu, a także niewidocznych z pozoru zależności i prawidłowości.
            Dzięki wymiarowi ilościowemu owe parametry, zależności i
            prawidłowości są naukowo bardziej przydatne, niż luźne impresje z
            lektury. Przykładem takiej analizy korpusowej jest ilościowy opis
            prasowego obrazu kolektywizacji wsi polskiej w latach powojennych.
            Może on posłużyć jako pomoc w badaniach m.in. historykom,
            antropologom, lingwistom i medioznawcom. Cechy korpusu ChronoPress,
            które wyróżniają go na tle innych narzędzi i pozwalają na takie
            analizy, to: – zawartość (trudno dostępne i zrównoważone tematycznie
            dane z tekstów prasowych z okresu PRL); – uporządkowanie
            chronologiczne (systematyczne daty wydań, które pozwalają na
            stosowanie różnych metod analizy chronologicznej danych); –
            konsekwentnie dodawane metadane.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UsageGuide",
  components: {},
  data() {
    return {
      usage: 1,
      isActive: true,
    };
  },
  methods: {},
  mounted() {
    this.usage = 1;
  },
};
</script>

<style scoped>
@media only screen and (max-width: 768px) {
  .wraper .menu {
    width: 10%;
    height: 100%;
    margin-right: 1.5rem;
    margin-left: 0;
  }
  .wraper .menu .menu-btn {
    width: 100%;
  }
  .usage-body {
    font-size: 12px;
  }
  .usage-body .content {
    width: 100%;
  }
  h3,
  h5 {
    font-size: 16px;
  }
}
@media only screen and (max-width: 375px) {
  .wraper {
    width: 50vw;
  }
  #list-title {
    transform: rotate(-90deg) translateY(-50%);
    margin-bottom: 2rem;
    margin-top: 3rem;
  }
  .wraper .menu {
    width: 20%;
    height: 100%;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    display: flex;
    align-content: flex-start;
    justify-content: flex-start;
  }
  .wraper .menu .menu-btn {
    width: 100%;
  }
  .usage-body .content {
    background-color: rgba(255, 127, 80, 0);
    width: 100%;
    font-size: 10px;
  }
  h3,
  h5 {
    font-size: 12px;
  }
}
.wraper {
  height: 70vh;
  width: 100%;
  overflow-y: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-bottom: 1rem;
}
.usage-body {
  display: flex;
  width: 50vw;
  font-size: 10px;
  padding: 1rem;
  margin-top: 0;
  padding-top: 0;
  display: flex;
  height: fit-content;
  margin-bottom: 1rem;
  text-align: justify;
  font-size: 16px;
}
.menu {
  display: flex;
  flex-direction: column;
  margin-right: 1rem;
  margin-left: 2rem;
  font-weight: bold;
  cursor: pointer;
  position: sticky;
  top: 1rem;
}
.active .menu-dot {
  background-color: coral;
}
.menu-dot {
  display: flex;
  width: 20px;
  height: 20px;
  background-color: rgb(116, 116, 116);

  margin-right: 1rem;
}
.menu-btn {
  display: flex;
  width: 7rem;
  height: 20px;
  margin-bottom: 1rem;
}
.menu-btn:hover {
  color: white;
  background-color: rgb(83, 83, 83);
}
.content {
  width: 85%;
}
h3 {
  font-weight: bold;
  margin-bottom: 3rem;
  margin-top: 2rem;
}
h5 {
  font-weight: bold;
}
.text-center {
  text-align: center;
  margin-left: 10rem;
}
.info {
  color: coral;
  text-decoration: underline coral dotted;
}
.info:hover:after {
  color: white;
  background-color: var(--grey_black);
  content: attr(title);
}
</style>

<style></style>



// WEBPACK FOOTER //
// src/components/UsageGuide.vue